import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useRecordContext } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { Typography } from 'shared/mui/Typography';

export function GatewayRulesFormMappingCommissionsOption(): JSX.Element {
  const translate = useTypedTranslate();
  const record = useRecordContext();

  return (
    <Box>
      <Typography variant="body1">{record?.name}</Typography>
      <Typography color="text.secondary" component="p" variant="caption">
        {`${translate('app.gatewayRules.commissionStatus')}: ${record?.status}`}
      </Typography>
      <Typography color="text.secondary" variant="caption">
        {`${translate('app.gatewayRules.commissionType')}: ${record?.transactionTypes?.join(' / ')}`}
      </Typography>
    </Box>
  );
}
